import { render } from "./ExportWithholdingTaxComponent.vue?vue&type=template&id=ae395274&scoped=true"
import script from "./ExportWithholdingTaxComponent.vue?vue&type=script&lang=js"
export * from "./ExportWithholdingTaxComponent.vue?vue&type=script&lang=js"

import "./ExportWithholdingTaxComponent.vue?vue&type=style&index=0&id=ae395274&scoped=true&lang=css"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae395274"]])

export default __exports__